import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import '@forevolve/bootstrap-dark/dist/css/bootstrap-dark.css';
import '@forevolve/bootstrap-dark/dist/js/bootstrap.bundle.js';

ReactDOM.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>,
  document.getElementById('root')
);
